import React from 'react';
import ChatMessageRow from './ChatMessageRow';
import { renderEventCancelledCardBody } from './eventSystemMessageUtils';

export default function EventCancelledSystemMessageRow({
  message,
  activeAnchorMessageId,
  anchorClassName = 'is-anchor-hit',
  rowClassName,
  bodyClassName,
  contentRowClassName,
  sourceBadgeClassName,
  timeClassName,
  resolveMessageSourceBadgeLabel,
  shouldShowMessageSourceBadge,
  formatDateTime,
  withAnnouncementScopeTitle,
  linkifyText,
  renderAnnouncementAvatarLeft,
}) {
  const timeLabel = typeof formatDateTime === 'function'
    ? formatDateTime(message?.created_at)
    : String(message?.created_at || '');
  const showSourceBadge = typeof shouldShowMessageSourceBadge === 'function'
    ? shouldShowMessageSourceBadge(message)
    : false;
  const sourceEventLabel = showSourceBadge && typeof resolveMessageSourceBadgeLabel === 'function'
    ? resolveMessageSourceBadgeLabel(message)
    : '';
  const resolvedRowClassName = [rowClassName, 'event-cancelled-system-row']
    .filter(Boolean)
    .join(' ');
  const preset = String(rowClassName || '').includes('im-row') ? 'im' : 'plain';

  return (
    <ChatMessageRow
      preset={preset}
      messageId={message?.id}
      rowClassName={resolvedRowClassName}
      classMap={{
        row: rowClassName || '',
        rowSelf: '',
        rowOther: '',
        body: bodyClassName || '',
        sender: '',
        line: contentRowClassName || '',
        read: '',
        bubble: '',
        timeWrap: '',
        time: timeClassName || '',
      }}
      bubbleClassName=""
      isSelf={false}
      showSender={false}
      avatarNode={typeof renderAnnouncementAvatarLeft === 'function' ? renderAnnouncementAvatarLeft(message) : null}
      anchorActive={String(activeAnchorMessageId) === String(message?.id)}
      anchorClassName={anchorClassName}
      beforeLineContent={showSourceBadge && sourceEventLabel ? (
        <span className={sourceBadgeClassName}>{sourceEventLabel}</span>
      ) : null}
      timeLabel={timeLabel}
    >
      {renderEventCancelledCardBody({
        message,
        withAnnouncementScopeTitle,
        linkifyText,
      })}
    </ChatMessageRow>
  );
}
